import { withStyles } from '@material-ui/core';
import { Spinner } from 'copilot-design-system';
import React, { useEffect, useState } from 'react';
import { Channel as ChannelType } from 'stream-chat';
import * as ChatCSS from 'stream-chat-react/dist/css/v2/index.css';

import { ChannelContent } from 'src/components/chat/inner-channel/channel-content/ChannelContent';
import { InnerChannel } from 'src/components/chat/inner-channel/InnerChannel';
import { NoMessagesEmptyState } from 'src/components/chat/inner-channel/NoMessagesEmptyState';
import { InternalChatProvider } from 'src/features/assistant/internalChatContext';
import { useAppSelector } from 'src/hooks/useStore';
// TODO in POR-15598: move this out of legacy (or even better, figure out a way to initialize the client universally so this isn't needed)
// eslint-disable-next-line no-restricted-imports
import { useChatClient } from 'src/legacy/components/Chat/useChatClient';
import { useMessagesStyles } from 'src/routes/messaging/MessagesPageStyles';

interface InternalChatProps {
  entityType: 'client' | 'company';
  /** Either a clientId or a companyId */
  entityId: string;
  internalChat?: ChannelType;
}

const InternalChatComponent = ({
  entityType,
  entityId,
  internalChat,
}: InternalChatProps) => {
  const chatClient = useChatClient();
  const currentUserGetStreamId = useAppSelector(
    (state) => state.user.data?.getstreamId || '',
  );
  const [internalChannel, setInternalChannel] = useState<
    ChannelType | undefined
  >(undefined);

  useEffect(() => {
    if (internalChat) {
      // if a channel is provided, we don't need to fetch it
      setInternalChannel(internalChat);
      return;
    }
    const fetchInternalChannel = async () => {
      if (chatClient) {
        const internalChannels = await chatClient.queryChannels({
          type: 'internal',
          members: {
            $in: [currentUserGetStreamId],
          },
          [entityType === 'client' ? 'clientID' : 'companyID']: entityId,
        });
        if (internalChannels.length !== 1) {
          // TODO: error handling (maybe with own error boundary?)
          console.error(
            'Incorrect number of channels returned, expected 1, got',
            internalChannels.length,
          );
        } else {
          setInternalChannel(internalChannels.at(0));
        }
      }
    };
    fetchInternalChannel().catch((e) => {
      // TODO: error handling (maybe with own error boundary?)
      console.error(e);
    });
  }, [chatClient, currentUserGetStreamId, entityType, entityId, internalChat]);

  // TODO: potentially either refactor for tailwind or move out of massaging routes
  const classes = useMessagesStyles({
    showMessagingSidebar: false,
    isInternalChat: true,
  });

  return (
    <>
      {internalChannel ? (
        <div className={classes.root}>
          <InternalChatProvider isInternalChat>
            <InnerChannel
              EmptyStateIndicator={NoMessagesEmptyState}
              channel={internalChannel}
            >
              <ChannelContent placeholderText="Chat with teammates or @Assembly" />
            </InnerChannel>
          </InternalChatProvider>
        </div>
      ) : (
        <div className="w-full h-full flex items-center justify-center">
          <Spinner size={10} />
        </div>
      )}
    </>
  );
};

// TODO: figure out how to apply these styles without material UI
export const InternalChat = React.memo(
  withStyles(ChatCSS)(InternalChatComponent),
);
